module.exports = __webpack_public_path__ + "img/support-information.d268f43a.svg";